module.exports = __webpack_public_path__ + "img/Mahjong_logo.6ff39d8b.png";